import { observable } from "@legendapp/state";

export const $clientEnded = observable(false);
